module.exports = __webpack_public_path__ + "img/product-sm-6.c00edb11.png";